import React from 'react';
import {
  Card,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';

export const VisualNavigationCard = (itemDetails) => {
  const { item, position } = itemDetails;
  let {
    enterpriseContentModel, image, id: itemID, link, description, title, previewImage
  } = item || {};

  let { description: altText, url: imageUrl } = image || {};

  const { ref, clickID } = useImpression({
    data: {
      id: itemID,
      component: 'VisualNavigation',
      name: 'VisualNavigation',
      type: 'content',
      position,
    },
  });

  if (previewImage) {
    let damDownloadedContentImage = previewImage?.damDownloadedContent;
    let damContentSelectorImage = previewImage?.damContentSelector?.assetData?.[0];

    if (damDownloadedContentImage?.url) {
      imageUrl = damDownloadedContentImage?.url;
    } else {
      imageUrl = damContentSelectorImage?.selectedImageUrl || imageUrl;
    }
  }

  if (enterpriseContentModel) {
    link = enterpriseContentModel.link_cta;
    description = enterpriseContentModel.subhead;
    title = enterpriseContentModel.headline_LessThan40Char;
    altText = enterpriseContentModel.image_siloh?.damDownloadedContent?.description;
    imageUrl = enterpriseContentModel.image_siloh?.damDownloadedContent?.url || imageUrl;
  }

  return (
    <div
      ref={ref}
      /* eslint-disable-next-line react/no-unknown-property */
      clickid={clickID}
      key={`card-position-${position}`}
      className={`${!imageUrl ? 'sui-align-middle' : ''} sui-flex sui-h-full sui-w-full`}
      data-component="VisualNavigationCard"
    >
      <Card
        key={itemID}
        href={link || description}
        target="_blank"
        rel="noreferrer"
        className="sui-w-full"
      >
        {imageUrl && (
          <CardMedia
            alt={`Image for ${altText || title}`}
            title={`Image for ${altText || title}`}
            src={imageUrl}
            aspect="square"
          />
        )}
        {title && (
          <CardTitle
            actionPosition="center"
            header={title}
            headerVariant="h5"
          />
        )}
      </Card>
    </div>
  );
};

const displayName = 'VisualNavigationCard';

const propTypes = {
};

const defaultProps = {
};

VisualNavigationCard.displayName = displayName;
VisualNavigationCard.propTypes = propTypes;
VisualNavigationCard.defaultProps = defaultProps;